import { useIntl, FormattedMessage } from 'react-intl';
import { faCheck } from '@fortawesome/pro-solid-svg-icons/faCheck';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { createColumnDefinitionBuilder } from 'ui-components/components/react-table-wrapper/create-column-definition-builder';

import { messages } from '../../../messages';
import styles from '../pick-list-grid.module.less';

import type { PickListGridItem } from '../pick-list-grid';

type DefaultCellProps = {
  row: { original: PickListGridItem };
  defaultTemplateKey?: string;
};

const DefaultCell = ({ row, defaultTemplateKey }: DefaultCellProps) => {
  const intl = useIntl();
  const isDefault = !!defaultTemplateKey && row.original.id === defaultTemplateKey;

  if (!isDefault) {
    return null;
  }

  return <FontAwesomeIcon aria-label={intl.formatMessage(messages.defaultIndicatorAriaLabel)} icon={faCheck} />;
};

export const createDefaultColumnDefinition = (defaultTemplateKey?: string) =>
  createColumnDefinitionBuilder({
    accessor: 'isDefault',
    Header: <FormattedMessage {...messages.gridColDefault} />,
    Cell: (cellProps: { row: { original: PickListGridItem } }) => <DefaultCell {...cellProps} defaultTemplateKey={defaultTemplateKey} />,
    width: 1,
    className: styles['default-cell'],
  })();
